import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function ShopCategoryDialog({ cat, onClose }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cat) return;
    setLoading(true);
    api
      .get("/products", { params: { category: cat.category } })
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, [cat]);

  return (
    <Dialog open={!!cat} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="shop-category-dialog"
        className="border-none"
        style={{ background: "var(--cream)", maxWidth: "860px", maxHeight: "86vh", overflowY: "auto" }}
      >
        <DialogHeader>
          <p className="eyebrow-v5" style={{ marginBottom: "8px" }}>
            Shop the edit
          </p>
          <DialogTitle
            style={{
              fontFamily: "var(--serif)",
              fontWeight: 500,
              fontSize: "30px",
              color: "var(--charcoal)",
              textAlign: "left",
              lineHeight: 1.25,
            }}
          >
            {cat?.title}
          </DialogTitle>
          <DialogDescription style={{ color: "var(--warm-mid)", fontFamily: "var(--sans)", fontSize: "13.5px" }}>
            Hand-picked Amazon favorites I truly use and love.
          </DialogDescription>
        </DialogHeader>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mt-4">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={`shop-skeleton-${i}`} className="aspect-[3/4]" style={{ background: "var(--dusty)", opacity: 0.4 }} />
            ))}
          </div>
        ) : products.length === 0 ? (
          <p style={{ color: "var(--warm-mid)", fontFamily: "var(--sans)", marginTop: "16px" }}>
            New picks coming soon — check back shortly.
          </p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mt-4">
            {products.map((p) => (
              <a
                key={p.id}
                data-testid={`shop-product-${p.id}`}
                href={p.amazon_url}
                target="_blank"
                rel="noreferrer"
                className="group block"
              >
                <div className="img-zoom" style={{ aspectRatio: "3 / 4", background: "var(--dusty)", borderRadius: "12px", overflow: "hidden" }}>
                  <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="mt-3 flex items-start justify-between gap-2">
                  <div>
                    <h4 style={{ fontFamily: "var(--serif)", fontSize: "17px", color: "var(--charcoal)", lineHeight: 1.2 }}>
                      {p.title}
                    </h4>
                    {p.price && (
                      <p style={{ fontFamily: "var(--sans)", fontSize: "13px", color: "var(--warm-mid)", marginTop: "2px" }}>
                        {p.price}
                      </p>
                    )}
                  </div>
                  <ArrowUpRight size={16} style={{ color: "var(--burgundy)", marginTop: "3px", flexShrink: 0 }} />
                </div>
                <span
                  className="link-underline"
                  style={{ fontFamily: "var(--sans)", fontSize: "12px", color: "var(--maroon)", display: "inline-block", marginTop: "6px" }}
                >
                  Shop on Amazon
                </span>
              </a>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
